var api = require("!../../../../../node_modules/.pnpm/style-loader@1.3.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../node_modules/.pnpm/raw-loader@4.0.2_webpack@5.106.2/node_modules/raw-loader/dist/cjs.js!../../../../../node_modules/.pnpm/sass-loader@10.2.0_sass@1.32.13_webpack@5.106.2/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./metric-chart.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};